<template>
    <div class="customer-area-component">
        <transition name="fade-slow">
            <customer-area-menu v-show="showMenu"></customer-area-menu>
        </transition>
        <transition name="fade-slow">
            <div class="content px-6 md:px-12 md:py-16 py-12 xl:px-16" v-show="showContent">
                <div class="content-container">
                    <transition name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { eventBus } from '../../app';
import CustomerAreaMenu from './CustomerAreaMenu';

export default {
    components: {
        CustomerAreaMenu,
    },

    data() {
        return {
            isDesktop: null,
        };
    },

    computed: {
        showMenu() {
            return this.isDesktop || this.$store.state.customer.mobileMenuShown;
        },
        showContent() {
            return this.isDesktop || ! this.$store.state.customer.mobileMenuShown;
        }
    },

    methods: {
        setIsDesktop() {
            this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        },
    },

    created () {
        eventBus.$on('something-went-wrong', () => {
            this.$toast.error(this.trans.get('customer.something-went-wrong'));
        });
    },

    mounted () {
        this.setIsDesktop();
        window.onresize = this.setIsDesktop;
    },
}
</script>

<style lang="scss">
.customer-area-page {
    .customer-area-component {
        display: grid;
        min-height: calc(100vh - 66px);
        // margin-top: 66px;
        margin-top: 110px;

        @media (max-width: 1023px) {
            .customer-area-menu-component,
            .content {
                grid-area: 1 / 1;
            }
        }

        @media (min-width: 1024px) {
            grid-template-columns: 25% 75%;
        }

        .fade-enter-active,
        .fade-slow-leave-active {
            transition: opacity .2s;
        }
        .fade-slow-enter-active {
            transition: opacity .4s;
        }
        .fade-enter,
        .fade-leave,
        .fade-leave-to,
        .fade-slow-enter,
        .fade-slow-leave-to {
            opacity: 0;
        }

        h2 {
            font-size: 2rem;
        }

        .content {
            background: white;

            .go-back-link {
                margin-top: 3px;
            }

            button.btn {
                min-width: 14rem;
            }
        }
    }
}
</style>
